export default __webpack_public_path__ + "assets/models/11374d1c4097160da68987a1e7bdecb5.glb";